import bbbbToken from "../abis/development/tokens/bbbbToken";

export default {
  name: "BBBB",
  abi: bbbbToken.abi,
  contractAddress: "0x64a7D4cE0cD67b109A3F1aC65A65be00549a00dA",
  decimals: 18,
};
